import React from 'react';
import { Logo } from '@stashinvest/ui';
import { NavContainer } from './Navbar.styles';

export const Navbar = () => (
	<NavContainer data-testid="global-stash-logo-header">
		<Logo zIndex="1" height="1.3rem" />
	</NavContainer>
);

export default Navbar;
